export default {
	january: [
		{
			day: "21/01",
			count: 7,
			lift_name: "Car 4",
		},
		{
			day: "18/01",
			count: 8,
			lift_name: "Car 3",
		},
		{
			day: "09/01",
			count: 9,
			lift_name: "Car 1",
		},
		{
			day: "21/01",
			count: 5,
			lift_name: "Car 4",
		},
		{
			day: "26/01",
			count: 5,
			lift_name: "Car 3",
		},
		{
			day: "19/01",
			count: 6,
			lift_name: "Car 5",
		},
		{
			day: "09/01",
			count: 3,
			lift_name: "Car 4",
		},
		{
			day: "29/01",
			count: 9,
			lift_name: "Car 1",
		},
		{
			day: "06/01",
			count: 4,
			lift_name: "Car 4",
		},
		{
			day: "16/01",
			count: 8,
			lift_name: "Car 2",
		},
		{
			day: "20/01",
			count: 8,
			lift_name: "Car 1",
		},
		{
			day: "13/01",
			count: 6,
			lift_name: "Car 1",
		},
		{
			day: "07/01",
			count: 9,
			lift_name: "Car 4",
		},
		{
			day: "29/01",
			count: 9,
			lift_name: "Car 5",
		},
		{
			day: "20/01",
			count: 10,
			lift_name: "Car 5",
		},
		{
			day: "17/01",
			count: 10,
			lift_name: "Car 4",
		},
		{
			day: "29/01",
			count: 9,
			lift_name: "Car 5",
		},
		{
			day: "25/01",
			count: 2,
			lift_name: "Car 4",
		},
		{
			day: "25/01",
			count: 5,
			lift_name: "Car 2",
		},
		{
			day: "27/01",
			count: 8,
			lift_name: "Car 1",
		},
		{
			day: "13/01",
			count: 4,
			lift_name: "Car 1",
		},
		{
			day: "17/01",
			count: 1,
			lift_name: "Car 5",
		},
		{
			day: "11/01",
			count: 2,
			lift_name: "Car 2",
		},
		{
			day: "15/01",
			count: 1,
			lift_name: "Car 2",
		},
		{
			day: "05/01",
			count: 7,
			lift_name: "Car 5",
		},
		{
			day: "04/01",
			count: 1,
			lift_name: "Car 4",
		},
		{
			day: "07/01",
			count: 1,
			lift_name: "Car 2",
		},
		{
			day: "17/01",
			count: 6,
			lift_name: "Car 4",
		},
		{
			day: "26/01",
			count: 9,
			lift_name: "Car 4",
		},
		{
			day: "21/01",
			count: 5,
			lift_name: "Car 3",
		},
		{
			day: "27/01",
			count: 5,
			lift_name: "Car 3",
		},
		{
			day: "31/01",
			count: 1,
			lift_name: "Car 1",
		},
		{
			day: "11/01",
			count: 2,
			lift_name: "Car 1",
		},
		{
			day: "25/01",
			count: 7,
			lift_name: "Car 1",
		},
		{
			day: "31/01",
			count: 4,
			lift_name: "Car 4",
		},
		{
			day: "20/01",
			count: 7,
			lift_name: "Car 4",
		},
		{
			day: "22/01",
			count: 5,
			lift_name: "Car 2",
		},
		{
			day: "17/01",
			count: 2,
			lift_name: "Car 5",
		},
		{
			day: "18/01",
			count: 8,
			lift_name: "Car 5",
		},
		{
			day: "10/01",
			count: 3,
			lift_name: "Car 4",
		},
		{
			day: "13/01",
			count: 2,
			lift_name: "Car 2",
		},
		{
			day: "04/01",
			count: 9,
			lift_name: "Car 2",
		},
		{
			day: "24/01",
			count: 1,
			lift_name: "Car 1",
		},
		{
			day: "04/01",
			count: 3,
			lift_name: "Car 2",
		},
		{
			day: "04/01",
			count: 4,
			lift_name: "Car 4",
		},
		{
			day: "20/01",
			count: 10,
			lift_name: "Car 1",
		},
		{
			day: "03/01",
			count: 6,
			lift_name: "Car 1",
		},
		{
			day: "24/01",
			count: 6,
			lift_name: "Car 3",
		},
		{
			day: "03/01",
			count: 3,
			lift_name: "Car 3",
		},
		{
			day: "29/01",
			count: 2,
			lift_name: "Car 3",
		},
		{
			day: "03/01",
			count: 10,
			lift_name: "Car 1",
		},
		{
			day: "09/01",
			count: 8,
			lift_name: "Car 1",
		},
		{
			day: "14/01",
			count: 9,
			lift_name: "Car 2",
		},
		{
			day: "20/01",
			count: 2,
			lift_name: "Car 3",
		},
		{
			day: "01/01",
			count: 5,
			lift_name: "Car 3",
		},
		{
			day: "14/01",
			count: 8,
			lift_name: "Car 5",
		},
		{
			day: "23/01",
			count: 1,
			lift_name: "Car 3",
		},
		{
			day: "15/01",
			count: 9,
			lift_name: "Car 3",
		},
		{
			day: "09/01",
			count: 1,
			lift_name: "Car 4",
		},
		{
			day: "25/01",
			count: 10,
			lift_name: "Car 4",
		},
		{
			day: "03/01",
			count: 2,
			lift_name: "Car 5",
		},
		{
			day: "14/01",
			count: 5,
			lift_name: "Car 5",
		},
		{
			day: "28/01",
			count: 4,
			lift_name: "Car 1",
		},
		{
			day: "11/01",
			count: 5,
			lift_name: "Car 2",
		},
		{
			day: "31/01",
			count: 6,
			lift_name: "Car 3",
		},
		{
			day: "22/01",
			count: 2,
			lift_name: "Car 4",
		},
		{
			day: "05/01",
			count: 6,
			lift_name: "Car 4",
		},
		{
			day: "08/01",
			count: 7,
			lift_name: "Car 1",
		},
		{
			day: "19/01",
			count: 9,
			lift_name: "Car 5",
		},
		{
			day: "17/01",
			count: 5,
			lift_name: "Car 1",
		},
		{
			day: "23/01",
			count: 4,
			lift_name: "Car 4",
		},
		{
			day: "17/01",
			count: 7,
			lift_name: "Car 4",
		},
		{
			day: "17/01",
			count: 6,
			lift_name: "Car 4",
		},
		{
			day: "05/01",
			count: 3,
			lift_name: "Car 1",
		},
		{
			day: "03/01",
			count: 2,
			lift_name: "Car 5",
		},
		{
			day: "01/01",
			count: 2,
			lift_name: "Car 3",
		},
		{
			day: "08/01",
			count: 9,
			lift_name: "Car 5",
		},
		{
			day: "12/01",
			count: 10,
			lift_name: "Car 1",
		},
		{
			day: "22/01",
			count: 7,
			lift_name: "Car 1",
		},
		{
			day: "18/01",
			count: 7,
			lift_name: "Car 5",
		},
		{
			day: "23/01",
			count: 8,
			lift_name: "Car 4",
		},
		{
			day: "07/01",
			count: 7,
			lift_name: "Car 5",
		},
		{
			day: "01/01",
			count: 8,
			lift_name: "Car 1",
		},
		{
			day: "30/01",
			count: 3,
			lift_name: "Car 3",
		},
		{
			day: "03/01",
			count: 7,
			lift_name: "Car 1",
		},
		{
			day: "03/01",
			count: 3,
			lift_name: "Car 5",
		},
		{
			day: "02/01",
			count: 1,
			lift_name: "Car 2",
		},
		{
			day: "08/01",
			count: 7,
			lift_name: "Car 1",
		},
		{
			day: "13/01",
			count: 9,
			lift_name: "Car 3",
		},
		{
			day: "23/01",
			count: 4,
			lift_name: "Car 3",
		},
		{
			day: "06/01",
			count: 1,
			lift_name: "Car 1",
		},
		{
			day: "15/01",
			count: 10,
			lift_name: "Car 1",
		},
		{
			day: "31/01",
			count: 4,
			lift_name: "Car 1",
		},
		{
			day: "15/01",
			count: 3,
			lift_name: "Car 1",
		},
		{
			day: "30/01",
			count: 6,
			lift_name: "Car 2",
		},
		{
			day: "27/01",
			count: 7,
			lift_name: "Car 1",
		},
		{
			day: "12/01",
			count: 9,
			lift_name: "Car 3",
		},
		{
			day: "03/01",
			count: 2,
			lift_name: "Car 4",
		},
		{
			day: "20/01",
			count: 2,
			lift_name: "Car 1",
		},
		{
			day: "24/01",
			count: 3,
			lift_name: "Car 3",
		},
	],
};
